import React from 'react';
import axios from 'axios';
import { Form, Input, Alert, Radio, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';

class GenderInclusiveHousing extends React.Component {
	state = {
		submitting: false
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'GENDINC');
			const data = Object.assign({}, values, (matchingRemark)?{id:matchingRemark.AssignId}:{});
			axios({
				method: (matchingRemark && matchingRemark.AssignId) ? 'put' : 'post',
				url: apiPath+'/remark/36',
				data: data,
				withCredentials: true
			}).then(result => {
				this.props.isSubmitted();
				this.props.refreshRemarks();
				message.success('Saved!');
			}).catch(error => {
				this.props.isSubmitted();
				this.props.handleAxiosSaveError(error);
			});
		});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'cabin/gender');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'cabin/gender');
			if (redirect) return redirect;
		}

		const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'GENDINC');
		const remark = Object.assign({
			rmkNumericCheck1: null,
			Comments: ''
		}, matchingRemark);

		const { getFieldDecorator } = this.props.form;
		return (
			<Form className="withSpacing" onSubmit={this.handleSubmit}>
				<p>
					Gender Inclusive Housing options may be available for students who are transgender, transsexual, intersex, and other diverse gender identities and expressions and allies.
					Checking the box below indicates that you are open to having a roommate with any gender identity.
					(ISE's default policy is to match roommates of the same sex as indicated on their passport.)
				</p>
				<Alert
					showIcon
					type="info"
					message={<span>For more information about Gender Inclusive Housing, see our FAQs <a target="_blank" href="http://www.semesteratsea.org/gender-inclusive-housing-faqs/">here</a>.</span>} />
				<Form.Item label="Would you like to participate?" className="inResco">
					{getFieldDecorator('participate', {
						initialValue: remark.rmkNumericCheck1,
						rules: [{required: true, message: 'Please indicate whether you would like to participate'}]
					})(
						<Radio.Group
							options={[{value: '1', label: 'Yes'}, {value: '0', label: 'No'}]}
							disabled={disabled}
							onChange={(e) => {
								if (e.target.value === '0') this.props.form.setFieldsValue({comments: ''});
							}} />
					)}
				</Form.Item>
				<Form.Item style={{display:(this.props.form.getFieldValue('participate') === '1') ? 'inherit' : 'none'}}
					label="Please share why you are interested in gender inclusive housing and what you are seeking in this cabin assignment" className="inResco wrapLabel">
					{getFieldDecorator('comments', {
						initialValue: remark.Comments,
						rules: [{max: 200, message: 'Comments are too long (max 200 characters)'}]
					})(
						<Input type="textarea" disabled={disabled} />
					)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.state.submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(GenderInclusiveHousing));



// WEBPACK FOOTER //
// ./portal-components/Portal/Cabin/GenderInclusiveHousing.jsx